import React from 'react';
import { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import LocationInformationComponent from './LocationInformationComponent';

interface Props {
    locationInformationRef: any
    selectedLoadingInformation: LocationInformationModel
    setSelectedLoadingInformation: React.Dispatch<React.SetStateAction<LocationInformationModel>>
    selectedUnloadingInformation: LocationInformationModel
    setSelectedUnloadingInformation: React.Dispatch<React.SetStateAction<LocationInformationModel>>
    getDistricts: (_countyId: string) => Promise<CustomSingleSelectModel[]>
}

export interface LocationInformationModel {
    selectedCountry: CustomSingleSelectModel | undefined
    selectedCounty: CustomSingleSelectModel | undefined
    selectedDistrict: CustomSingleSelectModel | undefined
}

const LocationInformation = ({
    locationInformationRef,
    selectedLoadingInformation,
    setSelectedLoadingInformation,
    selectedUnloadingInformation,
    setSelectedUnloadingInformation,
    getDistricts
}: Props) => {
    return (
        <div className='containerPart' ref={locationInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Lokasyon Bilgileri</h4>

                    <div className={'row'}>
                        <LocationInformationComponent
                            selected={selectedLoadingInformation}
                            setSelected={setSelectedLoadingInformation}
                            text='Yükleme'
                            getDistricts={getDistricts}
                        />

                        <LocationInformationComponent
                            selected={selectedUnloadingInformation}
                            setSelected={setSelectedUnloadingInformation}
                            text='Teslim'
                            getDistricts={getDistricts}
                        />
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default LocationInformation;